import Col from 'react-bootstrap/Col';
import styled from 'styled-components';

const ContenedorPrincipal = styled(Col)`
 
  box-shadow: ${(props) => props.invisible ? '' : '0px 0px 20px rgba(0, 0, 0, 0.1)'};
  border-radius: ${(props) => props.invisible ? '' : '10px'};
  
  
`;

export default ContenedorPrincipal;